import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { store } from './redux/store';
import { Background } from './components/Background';
import { Runcode } from './views/Runcode';

const LayoutComponent = () => (
	<Provider store={store}>
		<Background />
		<Runcode />
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.Runcode)
	.setHudVisible(true)
	.build();

export default Layout;
